<template>
    <main>
        <!-- breadcrumb area start here -->
        <section class="bd-breadcrumb-area p-relative fix theme-bg">
            <!-- breadcrumb background image -->
            <div class="bd-breadcrumb-bg" :style="{ backgroundImage: 'url(/img/bg/breadcrumb-bg.jpg)' }"></div>
            <div class="bd-breadcrumb-wrapper mb-60 p-relative">
                <div class="container">
                    <div class="bd-breadcrumb-shape d-none d-sm-block p-relative">
                        <div class="bd-breadcrumb-shape-1">
                        </div>
                        <div class="bd-breadcrumb-shape-2">
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-xl-10">
                            <div class="bd-breadcrumb d-flex align-items-center justify-content-center">
                                <div class="bd-breadcrumb-content text-center">
                                    <h1 class="bd-breadcrumb-title">Fee Structure</h1>
                                    <div class="bd-breadcrumb-list">
                                        <span><a href="/"><i class="flaticon-hut"></i>Home</a></span>
                                        <div class="bd-breadcrumb-list">
                                            <span><a href="#">Admission</a></span>
                                        </div>
                                        <span>Fee Structure</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="bd-wave-wrapper bd-wave-wrapper-3">
                <div class="bd-wave bd-wave-3"></div>
                <div class="bd-wave bd-wave-3"></div>
            </div>
        </section>
        <!-- breadcrumb area end here  -->
 <section class="fee-main-section">

            <!-- Heading -->
            <div class="fee-heading">
                <div class="fee-cap-icon">
                    <i class="fas fa-graduation-cap"></i>
                </div>

                <div class="fee-title-row">
                    <span class="fee-laurel">❧</span>
                    <h2>Fee Structure</h2>
                    <span class="fee-laurel">❧</span>
                </div>

                <div class="fee-session">
                    <span></span>
                    <div>Main Courses • Session 2026–27</div>
                    <span></span>
                </div>
            </div>

            <!-- Table -->
            <div class="fee-table-card">
                <div class="fee-table-responsive">
                    <table class="fee-table">
                        <thead>
                            <tr>
                                <th>Course Name</th>
                                <th>Fee Per<br>Students</th>
                                <th>Insurance<br>Per</th>
                                <th>Total Fee<br>Per</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="course in courses" :key="course.name">
                                <td>{{ course.name }}</td>
                                <td>{{ course.fee }}</td>
                                <td>{{ course.insurance }}</td>
                                <td>{{ course.total }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Information -->
            <div class="fee-info-box">
                <div class="fee-info-icon">
                    <i class="fas fa-info"></i>
                </div>

                <p>
                    Fee structure applicable for Academic Session 2026–27.
                    Please contact the school administration for additional
                    information regarding fees.
                </p>
            </div>

        </section>
    </main>
</template>

<script>
export default {
    name: "FeesView",

    data() {    
        return {
            courses: [
                { name: "Nursery Class", fee: "4,200", insurance: "225", total: "4,425" },
                { name: "LKG Class", fee: "4,200", insurance: "225", total: "4,425" },
                { name: "UKG Class", fee: "4,200", insurance: "225", total: "4,425" },
                { name: "I Standard", fee: "5,700", insurance: "225", total: "5,925" },
                { name: "II Standard", fee: "5,700", insurance: "225", total: "5,925" },
                { name: "III Standard", fee: "5,700", insurance: "225", total: "5,925" },
                { name: "IV Standard", fee: "6,300", insurance: "225", total: "6,525" },
                { name: "V Standard", fee: "6,300", insurance: "225", total: "6,525" },
                { name: "VI Standard", fee: "7,800", insurance: "225", total: "8,025" },
                { name: "VII Standard", fee: "8,800", insurance: "225", total: "9,025" },
                { name: "VIII Standard", fee: "9,200", insurance: "225", total: "9,425" },
                { name: "IX Standard", fee: "11,000", insurance: "225", total: "11,225" },
                { name: "X Standard", fee: "12,500", insurance: "225", total: "12,725" },
                { name: "XI Standard Commerce", fee: "14,300", insurance: "225", total: "14,525" },
                { name: "XII Standard Commerce", fee: "16,500", insurance: "225", total: "16,725" },
                { name: "XI Standard Science Math's", fee: "16,500", insurance: "225", total: "16,725" },
                { name: "XII Standard Science Math's", fee: "18,500", insurance: "225", total: "18,725" },
                { name: "XI Standard Science Biology", fee: "16,500", insurance: "225", total: "16,725" },
                { name: "XII Standard Science Biology", fee: "18,500", insurance: "225", total: "18,725" },
                { name: "XI Standard Arts", fee: "14,300", insurance: "225", total: "14,525" },
                { name: "XII Standard Arts", fee: "16,500", insurance: "225", total: "16,725" }
            ]
        };
    }
};
</script>